export default (function (obj, key) {
  return obj.hasOwnProperty(key);
});